import { Box, Button, CircularProgress, Typography } from '@mui/material';
import React from 'react';
import DownloadIcon from '../../../assets/icons/download-icon';
import useStyles from './styles';

const DownloadFlashLogReport = ({ row, callback }: { row: any; callback: Function }) => {
  const classes = useStyles();
  const [isLoading, setLoading] = React.useState(false);

  const handleClick = (row: any) => {
    callback(row, setLoading);
    // setLoading(true);
  };

  return (
    <Box display="flex" justifyContent="flex-end">
      <Button
        className={classes.root}
        id={`download-flashlog-report-${row.reportDate}`}
        onClick={() => handleClick(row)}
        variant="outlined"
        size="small"
        endIcon={isLoading ? <CircularProgress size={18} /> : <DownloadIcon />}
        disabled={isLoading}
      >
        <Typography variant="button">
          {isLoading ? 'Processing Report' : 'Download Report'}
        </Typography>
      </Button>
    </Box>
  );
};

export default DownloadFlashLogReport;
